import { usePlayerStoreApi } from "@utils/player/core/usePlayer";
import LBox from "@components/LBox";
import LIcon from "@components/LIcon";
import OptionsButton from "@components/SongOptions/OptionsButton";
import LPressable from "@components/LPressable";
import SaveButton from "./SaveButton";
import { theme } from "@theme";
import {
  useActiveCollectionId,
  useActiveCollectionType,
  useActiveSong,
  useIsPlaying,
  usePlayerControls,
} from "@utils/player";

const PlayerControls = () => {
  const playerStore = usePlayerStoreApi();

  // Use granular hooks - only re-renders on play/pause, not progress updates
  const isPlaying = useIsPlaying(); // Only re-renders on play/pause
  const { togglePlay } = usePlayerControls();
  const activeSong = useActiveSong();
  const collectionId = useActiveCollectionId();
  const collectionType = useActiveCollectionType();
  const isAudioPlaying = isPlaying;
  if (!activeSong) {
    return null;
  }

  if (!collectionId || !collectionType) {
    return null;
  }

  return (
    <LBox
      flexDirection="row"
      justifyContent="center"
      alignItems="center"
      height="100%"
    >
      <OptionsButton
        activeSong={activeSong}
        iconSize={32}
        selectedCollection={{
          collectionId,
          collectionType: collectionType as any,
        }}
        sentryEventName="music_player_options"
        style={{
          paddingRight: theme.spacing.s2_5,
        }}
      />
      <SaveButton song={activeSong} />
      <LPressable
        hitSlop={{ top: 12, bottom: 12 }}
        sentryEventName={`bar_music_player_${isAudioPlaying ? "pause" : "play"}`}
        onPress={() => {
          // Read from store directly to avoid subscriptions
          const store = playerStore.getState();
          if (
            store.hasReachedPlaybackLimit &&
            store.playbackLimitConfig.enabled
          ) {
            store.playbackLimitConfig.onLimitReached();
            return;
          }
          togglePlay();
        }}
        style={{
          paddingHorizontal: theme.spacing.s2_5,
        }}
      >
        <LIcon name={isAudioPlaying ? "pause" : "play"} size={24} />
      </LPressable>
    </LBox>
  );
};

export default PlayerControls;
